import request from '@/utils/ajax';

export function addConfig(data){
  return request({
    url: `/wx/sys/config/save`,
    method: 'POST',
    data: data
  });
}

export function editConfig(data){
  return request({
    url: `/wx/sys/config/update`,
    method: 'POST',
    data: data
  });
}

export function deleteConfig(data){
  return request({
    url: `/wx/sys/config/delete`,
    method: 'POST',
    data: data
  });
}

export function queryConfigDone(data){
  return request({
    url: `/wx/sys/oss/config`,
    method: 'get',
    params: data
  });
}

/**
 * data需要formData
 * @param data
 * @returns {*}
 */
export function uploadFile(data){
  return request({
    url: `/wx/sys/oss/upload`,
    method: 'post',
    data
  });
}
